"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import _ from "lodash";
import DistributionDialog from "@/components/dialog/DistributionDialog.vue";
import API from "@ym-framework/api-utils";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
import ShopOnlyChooseUsers from "@/views/bindItems/ShopOnlyChooseUsers.vue";
let TransferShopDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.activeName = "first";
    this.selectDatas = [];
    this.selectVDDatas = [];
    this.choose_users = [];
    this.select_users = [];
    this.selectLock = false;
    this.account_info = "";
    this.user_id = "";
    this.searchStr = "";
    this.gridController = new GridController(
      // new APIDataSource(`api://base.auth/api/v7/groups/shop_list`)
      // base.auth.pro
      // 需要重构店铺列表接口
      new APIDataSource(`api://base.auth.pro/v1/shops`)
    );
    this.vdgridController = new GridController(
      // new APIDataSource(`api://base.auth/api/v7/virtual_desktops`)
      // base.auth.pro
      // 需要重构VD列表接口
      new APIDataSource(`api://base.auth.pro/v1/virtual-desktops`)
    );
    this.searchByName = _.debounce((searchStr) => __async(this, null, function* () {
      yield this.checkSearch(searchStr);
    }), 500);
  }
  created() {
    return __async(this, null, function* () {
      this.gridController.on("searched", (item) => {
        this.selectedCheck();
      });
      this.vdgridController.on("searched", (item) => {
        this.selectedVDCheck();
      });
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  open(user_data) {
    return __async(this, null, function* () {
      let _text = user_data.account + " " + user_data.name + " " + user_data.role_name;
      this.account_info = _text;
      this.user_id = user_data.guid;
      this.selectDatas = [];
      this.selectVDDatas = [];
      this.choose_users = [];
      this.select_users = [];
      this.searchStr = "";
      this.selectLock = false;
      this.gridController.query.params = null;
      this.vdgridController.query.params = null;
      this._distribution_shop.open();
      this._distribution_shop.setBtn(false);
      this._distribution_shop.setOptSpan(16, 8);
      this.gridController.pagePosition = "dialog";
      this.vdgridController = new GridController(new APIDataSource(`api://base.auth.pro/v1/users/${this.user_id}/virtual-desktops-page`));
      this.vdgridController.on("searched", (item) => {
        this.selectedVDCheck();
      });
      this.vdgridController.pagePosition = "dialog";
      this.vdgridController.query.params = {
        search: `createdTime=sort=desc;`,
        type: "BRIEF"
      };
      this.gridController.query.params = {
        search: `userIds=in=${this.user_id};createdTime=sort=desc;`,
        type: "USER_BIND"
      };
      yield this.vdgridController.search();
      yield this.gridController.search();
    });
  }
  cheangTabs() {
    return __async(this, null, function* () {
      this.selectDatas = [];
      this.selectVDDatas = [];
      this._distribution_shop.clear();
      this.searchStr = "";
      if (this.activeName === "first") {
        this.gridController.query.params = {
          search: `userIds=in=${this.user_id};createdTime=sort=desc;`,
          type: "USER_BIND"
        };
        yield this.gridController.search();
      }
      if (this.activeName === "second") {
        this.vdgridController.query.params = {
          search: `createdTime=sort=desc;`,
          type: "BRIEF"
        };
        yield this.vdgridController.search();
      }
    });
  }
  saveUsers(data) {
    this.choose_users = data;
    let ids = _.map(data, "id");
    this.select_users = ids;
  }
  showChooseUsers() {
    return __async(this, null, function* () {
      this._shopOnlyChooseUsers.open(this.choose_users);
    });
  }
  checkSearch(searchStr) {
    return __async(this, null, function* () {
      if (this.activeName === "first") {
        if (searchStr !== null && searchStr !== "") {
          this.gridController.query.params = {
            type: "USER_BIND",
            search: `userIds=in=${this.user_id},name=like='${searchStr}';createdTime=sort=desc;`
          };
        }
        if (searchStr === null || searchStr === "") {
          this.gridController.query.params = {
            type: "USER_BIND",
            search: `userIds=in=${this.user_id};createdTime=sort=desc;`
          };
        }
        this.gridController.query.current = 1;
        this.gridController.search();
      }
      if (this.activeName === "second") {
        if (searchStr !== null && searchStr !== "") {
          this.vdgridController.query.params = {
            search: `name=like='${searchStr}';createdTime=sort=desc;`,
            type: "BRIEF"
          };
        }
        if (searchStr === null || searchStr === "") {
          this.vdgridController.query.params = {
            search: `createdTime=sort=desc;`,
            type: "BRIEF"
          };
        }
        this.vdgridController.query.current = 1;
        this.vdgridController.search();
      }
    });
  }
  selectedCheck() {
    let rows = _.intersectionWith(this.gridController.result.datas, this.selectDatas, (selectData, data) => selectData.id === data.id);
    if (rows) {
      for (const row of rows) {
        this._multipleTable.toggleRowSelection(row, true);
      }
    }
  }
  selectedVDCheck() {
    let rows = _.intersectionWith(this.vdgridController.result.datas, this.selectVDDatas, (selectData, data) => selectData.id === data.id);
    if (rows) {
      for (const row of rows) {
        this._vdmultipleTable.toggleRowSelection(row, true);
      }
    }
  }
  getUsers(item) {
    if (item.length > 0) {
      let arr = [];
      for (let data of item) {
        arr.push(data.label);
      }
      return arr.join(",");
    }
    return this.$t("virtualdesktopform.choose_users");
  }
  // 问题出在这里 如果切换搜索条件或者切换页面 他会被触发 所以需要修改
  selectItems(items) {
    if (!this.selectLock) {
      this._distribution_shop.syncData(
        this.gridController.result.datas,
        items,
        "id",
        "name"
      );
      this.selectDatas = this._distribution_shop.getAll();
    }
  }
  selectVDItems(items) {
    if (!this.selectLock) {
      this._distribution_shop.syncData(
        this.vdgridController.result.datas,
        items,
        "id",
        "name"
      );
      this.selectVDDatas = this._distribution_shop.getAll();
    }
  }
  changed(data) {
    this.selectLock = true;
    if (this.activeName === "first") {
      let rows = _.differenceWith(
        this.selectDatas,
        data,
        (selectData, data2) => selectData.id == data2.id
      );
      if (rows) {
        for (const row of rows) {
          let item = _.find(this.gridController.result.datas, { "id": row.id });
          if (item) {
            this._multipleTable.toggleRowSelection(item, false);
          }
        }
      }
      this.selectDatas = data;
    }
    if (this.activeName === "second") {
      let rows = _.differenceWith(
        this.selectVDDatas,
        data,
        (selectData, data2) => selectData.id == data2.id
      );
      if (rows) {
        for (const row of rows) {
          let item = _.find(this.vdgridController.result.datas, { "id": row.id });
          if (item) {
            this._vdmultipleTable.toggleRowSelection(item, false);
          }
        }
      }
      this.selectVDDatas = data;
    }
    this.selectLock = false;
  }
  saved(data) {
    return __async(this, null, function* () {
      try {
        let _move_ids = _.map(data, "id");
        if (this.activeName === "first") {
          yield API.put(`api://base.auth.pro/v1/user/handover`, {
            "model": "user.handover.shop",
            "shopIds": _move_ids,
            "userId": this.user_id,
            "targetUserIds": this.select_users
          });
          this.$message.success(this.$t("transfer_shop.success_message"));
        }
        if (this.activeName === "second") {
          yield API.put(`api://base.auth.pro/v1/user/handover`, {
            "model": "user.handover.vd",
            "vdIds": _move_ids,
            "userId": this.user_id,
            "targetUserIds": this.select_users
          });
          this.$message.success(this.$t("transfer_shop.vd_success_message"));
        }
        this._distribution_shop.close();
        this.$emit("success");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  Ref("distribution-shop")
], TransferShopDialog.prototype, "_distribution_shop", 2);
__decorateClass([
  Ref("multipleTable")
], TransferShopDialog.prototype, "_multipleTable", 2);
__decorateClass([
  Ref("vdmultipleTable")
], TransferShopDialog.prototype, "_vdmultipleTable", 2);
__decorateClass([
  Ref("shopOnlyChooseUsers")
], TransferShopDialog.prototype, "_shopOnlyChooseUsers", 2);
TransferShopDialog = __decorateClass([
  Component({
    components: {
      DistributionDialog,
      UiGrid,
      ShopOnlyChooseUsers
    }
  })
], TransferShopDialog);
export {
  TransferShopDialog as default
};
